import { render, staticRenderFns } from "./resumenPaises.vue?vue&type=template&id=045c1b7c&scoped=true&"
import script from "./resumenPaises.vue?vue&type=script&lang=js&"
export * from "./resumenPaises.vue?vue&type=script&lang=js&"
import style0 from "./resumenPaises.vue?vue&type=style&index=0&id=045c1b7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c1b7c",
  null
  
)

export default component.exports